import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedGroupID, clearSelectedGroupID } from "../features/groups/groupSlice";
import { useAppSelector } from "../app/hooks";
import { selectDevice } from "../features/devices/deviceSlice";
import { selectDashboard } from "../features/dashboards/dashboardSlice";

const useUpdateSelectedGroupID = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const deviceID = pathname.includes("device/") ? pathname.split("/")[2] : undefined;
  const dashboardID = pathname.includes("dashboard/")
    ? pathname.split("/")[2]
    : undefined;

  const device = useAppSelector((state) =>
    deviceID ? selectDevice(state, deviceID) : undefined
  );
  const dashboard = useAppSelector((state) =>
    dashboardID ? selectDashboard(state, dashboardID) : undefined
  );

  useEffect(() => {
    if (pathname.includes("group/")) {
      const groupID = pathname.split("/")[2];
      groupID ? dispatch(setSelectedGroupID(groupID)) : dispatch(clearSelectedGroupID());
    } else if (pathname.includes("device/")) {
      device?.group_id
        ? dispatch(setSelectedGroupID(device.group_id))
        : dispatch(clearSelectedGroupID());
    } else if (pathname.includes("dashboard/")) {
      dashboard?.group_id
        ? dispatch(setSelectedGroupID(dashboard.group_id))
        : dispatch(clearSelectedGroupID());
    } else {
      dispatch(clearSelectedGroupID());
    }
  }, [pathname, dispatch, device, dashboard]);
};

export default useUpdateSelectedGroupID;
